//异步操作 发起mutations来更改状态
import Vue from 'vue';
export default{
    actionsUserInfo(context){
        //context是一个与store实例具有相同方法和属性的context对象
        //这个异步操作  我们可以发送ajax请求和定时器
        Vue.prototype.$axios.post('/',{
            uid:localStorage.getItem('uid'),
            token:localStorage.getItem('token'),
            service:'PCUser.GetBaseInfo'
        }).then((response) => {
            let res = response.data.data;
            if(res.code == 0){
                context.commit('getUserInfo',res.info[0]);
            }
        })
    },
    // actionsDownloadImg(context){
    //     Vue.prototype.$axios.post('/',{
    //         service:'PCHome.download',
    //     }).then((response) => {
    //         let res = response.data.data;
    //         if(res.code == 0){
    //             context.commit('setDownloadImg',res.info[0]);
    //         }
    //     })
    // }
}


// WEBPACK FOOTER //
// ./src/store/actions.js